import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import UserProfile from "./UserProfile";
import CreateTeam from "./CreateTeam";
import ListTeam from "./ListTeam";
import TeamDetails from "./TeamDetails";

class UserProfileRoutes extends Component {
  render() {
    let { history } = this.props;
    return (
      <Switch>
        <Route
          exact
          path="/profile"
          history={history}
          component={UserProfile}
        />
        <Route
          exact
          path="/profile/list/:type"
          history={history}
          component={ListTeam}
        />
        <Route
          exact
          path="/profile/details/:type/:id"
          history={history}
          component={TeamDetails}
        />
        <Route
          exact
          path="/profile/cteam/:type"
          history={history}
          component={CreateTeam}
        />
      </Switch>
    );
  }
}

export default UserProfileRoutes;



// WEBPACK FOOTER //
// ./src/customers/profile/routes.jsx